import { render, staticRenderFns } from "./product-select.vue?vue&type=template&id=162595c4&"
import script from "./product-select.vue?vue&type=script&lang=js&"
export * from "./product-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports